import {Dialog} from "@components/interface/Dialog";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {ChangeEventHandler, CSSProperties, useCallback, useState} from "react";
import {THEME, COLOURS} from "@components/core/theme";
import {Game} from "@game/game";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    paragraph: {
        marginTop: 8,
        marginBottom: 8
    },
    nickname: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1
    },
    warning: {
        alignSelf: "end",
        color: COLOURS.amber,
        margin: "0 4px",
        transition: "opacity 0.3s ease"
    }
}

interface IAddNickname {
    game: Game
}

export function SelectNicknameDialog({game}: IAddNickname) {
    const [, gameState] = useState<{}>();
    const [nickname, setNickname] = useState("");
    const forceUpdate = useCallback(() => gameState({}), []);
    const handleChange:ChangeEventHandler<HTMLInputElement> = ({target}) =>
        setNickname(target.value);
    const handleDefer = () => {
        localStorage.setItem("deferNickname", "true");
        forceUpdate();
    }
    const handleSelect = () => {
        game.userPlayer?.selectNickname(nickname).then(() => {
            forceUpdate();
        });
    }

    if (! game.userPlayer || game.userPlayer.anonymous ||
        game.userPlayer.hasNickname() ||
        localStorage.getItem("deferNickname") === "true") {
        return null;
    }
    return (
        <Dialog title="NicknameTitle">
            <div style={styles.paragraph}>
                <LocalisedTypography content="NicknameHelp1"/>
                <LocalisedTypography content="NicknameHelp2"/>
            </div>
            <div style={styles.nickname}>
                <div style={{...styles.labelledInput, flexGrow: 0}}>
                    <div style={styles.label}>
                        <LocalisedTypography content="NicknameLabel"/>
                    </div>
                    <input onChange={handleChange} style={styles.input} value={nickname}/>
                </div>
                <div style={{...styles.warning, opacity: nickname.length > 0 && !game.wordlist.legal(nickname) ? 1 : 0}}>
                    Your name must be a valid Wordland word
                </div>
            </div>
            <div style={styles.buttons}>
                <button disabled={!game.wordlist.legal(nickname)} onClick={handleSelect} style={styles.button}>
                    <LocalisedTypography content="NicknameSelect"/>
                </button>
            </div>
            <div style={styles.paragraph}>
                <LocalisedTypography content="NicknameDeferText"/>
            </div>
            <div style={styles.buttons}>
                <button onClick={handleDefer} style={styles.button}>
                    <LocalisedTypography content="NicknameDefer"/>
                </button>
            </div>
        </Dialog>
    );
}